/* eslint-disable @nx/enforce-module-boundaries */
import './i18n';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { AccountModificationFlowId } from '@ctct/infrastructure-layer';

import { RedirectToBillingApp } from './components/RedirectToBillingApp';
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics';
import { BillingInfoPage, BuyNow, Checkout, OverdueBalancePage, SingleBillPage } from './pages';
// todo: define a better structure for our code & fix it once we move the secure app to the new repo
import { MoretonBayPage } from './pages/MoretonBayPage';
import { ErrorBoundary } from '../../../../libs/myaccount-utils-static/src/js/components/ErrorBoundary';
import { observabilityAppService } from '../../../../libs/myaccount-utils-static/src/js/utils/ObservabilityAppService';

const client = new QueryClient();

const AppRoutes = () => {
  useGoogleAnalytics();

  return (
    <BrowserRouter>
      <RedirectToBillingApp>
        <Switch>
          <Route exact path="/billinginfo" component={BillingInfoPage} />
          <Route exact path="/singlebill" component={SingleBillPage} />
          <Route path="/buynow" component={BuyNow} />
          <Route path="/purchase" render={() => <Checkout flowId={AccountModificationFlowId.Purchase} />} />
          <Route
            path="/payment-plan"
            render={() => <Checkout flowId={AccountModificationFlowId.ChangePaymentPlan} />}
          />
          <Route exact path="/overduebalance" component={OverdueBalancePage} />
          <Route path="/moreton-bay" component={MoretonBayPage} />
        </Switch>
      </RedirectToBillingApp>
    </BrowserRouter>
  );
};

const App = () => (
  <ErrorBoundary notifier={observabilityAppService}>
    <QueryClientProvider client={client}>
      <AppRoutes />
    </QueryClientProvider>
  </ErrorBoundary>
);

const initApp = () => {
  const root = ReactDOM.createRoot(document.getElementById('root')!);

  root.render(<App />);
};

// If we're loading in rise, we have to wait for hydration to finish
// before we can start adding things to the DOM
// eslint-disable-next-line no-underscore-dangle
if (document.__ctct_isRise && !document.__ctct_hydrationComplete) {
  document.addEventListener('hydrationComplete', () => initApp(), { once: true });
} else {
  initApp();
}
